<template>
  <div class="loading">
    <header class="header">
      <div class="header__content">
        <div class="header__content__menu">
          <img
            class="header__content__menu__logo"
            src="@/assets/img/logo.jpg"
            alt="Katılım Emeklilik"
            title="Katılım Emeklilik"
          />
          <div class="menu-nav">
            <router-link
              class="menu-nav__item"
              :to="{ name: 'individual' }"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                :class="{ '-active': isActive }"
                @click="navigate"
              >
                Ana sayfa
              </a>
            </router-link>
            <div class="menu-nav__sub">
              <div class="menu-nav__sub__title">Bireysel Emeklilik</div>
            </div>
            <div class="menu-nav__sub">
              <div class="menu-nav__sub__title">Sigortalar</div>
            </div>
          </div>
        </div>
        <div class="header__content__profile">
          <!-- <div :is="`Profile${type}`" :data="data"></div> -->
        </div>
      </div>
    </header>
    <div class="loading__icon">
      <icon-loading />
    </div>
    <main-footer />
  </div>
</template>
<script>
import MainFooter from "@/components/MainFooter.vue";
export default {
  components: {
    MainFooter,
  },
};
</script>